import React, { useEffect } from "react";
import AccountLayout from "../../blocs/AccountLayout";
import CardRdv from "../../components/CardRdv";
import { useDispatch, useSelector } from "react-redux";
import { fetchDemandesRendezvous } from "../../store/slices/rendezVousPrestaSlice";
import Pagination from "../../components/Pagination";
import CardRdvSkeleton from "../../components/skeletons/CardRdvSkeleton";

function DemandeRdv() {
  const dispatch = useDispatch();
  // const { demandes, status, error } = useSelector((state) => state.rdvPresta);
  const {
    demandes,
    status,
    error,
    current_page,
    per_page,
    last_page,
    itemsPerPage,
  } = useSelector((state) => state.rdvPresta);

  // console.log("demandes", demandes);
  // console.log("per_page", per_page);

  useEffect(() => {
    dispatch(
      fetchDemandesRendezvous({ page: current_page, perPage: per_page })
    );
  }, [dispatch, current_page, per_page]);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= last_page) {
      dispatch(fetchDemandesRendezvous({ page, itemsPerPage }));
    }
  };

  // Changement du nombre d'éléments par page
  const handlePerPageChange = (perPage) => {
    dispatch(fetchDemandesRendezvous({ page: 1, itemsPerPage: perPage }));
  };

  return (
    <>
      <AccountLayout bgColor={"bgColor"}>
        <h3 className="pd-bt-28">Demandes de rendez-vous</h3>

        <div className="row gx-4 gy-4">
          {status === "loading"
            ? [...Array(4)].map((_, i) => <CardRdvSkeleton key={i} />)
            : demandes.map((rdv, index) => (
                <>
                  <CardRdv
                    key={index}
                    rdvDetails={rdv}
                    borderNone="borderNone"
                  />
                </>
              ))}
          {demandes.length > 0 && (
            <Pagination
              currentPage={current_page}
              lastPage={last_page}
              perPage={per_page}
              onPageChange={handlePageChange}
              onPerPageChange={handlePerPageChange}
            />
          )}
        </div>
      </AccountLayout>
    </>
  );
}

export default DemandeRdv;
